import { 
    Component, 
    Input, 
    Output, 
    ViewChild, 
    ViewChildren, 
    ElementRef, 
    AfterContentInit, 
    OnInit, 
    EventEmitter, 
    OnChanges, 
    SimpleChanges, 
    QueryList, 
    AfterViewInit } from '@angular/core'

export interface tabButtonData {
    label: string,
    html?: string,
    tabContentIndex?: number,
    disabled?: boolean
    hidden?: boolean
    tabId?: string
}

@Component({
    selector: 'app-tabs',
    templateUrl: 'tabs.html',
    styleUrls: ['tabs.scss']
})
export class TabsComponent implements OnInit, AfterContentInit, OnChanges, AfterViewInit {

    @Input() buttonsData?: tabButtonData[]
    @Input() tabsClassname?: string
    @Input() buttonClassname?: string
    @Input() buttonActiveClassname?: string
    @Input() tabContentContainerClassname: string
    @Input() componentClassname: string
    @Input() setActiveTabIndexAs: number | undefined
    @Input() setActiveTabContentOverrideIndexAs: number | undefined

    activeTabIndex: number  
    activeTabContentClassname: string 
    buttonsAsContent = false
    displayAsContent = false
    buttonActiveClassnames: string[]

    @Output() tabSwitched = new EventEmitter<number>()

    @ViewChild('tabButtons', { static: true }) tabButtons: ElementRef<HTMLElement>
    @ViewChildren('tabButton') tabButton: QueryList<ElementRef<HTMLElement>>;
    @ViewChild('tabContent', { static: true }) tabContent: ElementRef<HTMLElement>

    ngOnInit(): void {
        this.tabsClassname = this.tabsClassname || '_tabs-x'
        this.activeTabIndex = this.setActiveTabIndexAs || 1
        this.activeTabContentClassname = `active-tab-${this.setActiveTabContentOverrideIndexAs || this.activeTabIndex}`
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.setActiveTabIndexAs?.currentValue !== changes?.setActiveTabIndexAs?.previousValue) {
            this.switchActiveTab(changes?.setActiveTabIndexAs?.currentValue, this.setActiveTabContentOverrideIndexAs)
        }
    }

    ngAfterViewInit(): void {
        let activeTabButtonEl

        if (this.tabButton.length) {
            activeTabButtonEl = this.tabButton.find(button => button.nativeElement.classList.contains('active-tab'))?.nativeElement;
        }

        if (activeTabButtonEl) {
            activeTabButtonEl.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'end', 
                inline: 'nearest'   
            })
        }
    }   

    ngAfterContentInit(): void {
        this.buttonsAsContent = !!this.tabButtons.nativeElement.children.length
        this.displayAsContent = !!this.tabContent.nativeElement.children.length

        if (this.buttonsAsContent) {

            let childCount = 1;

            if (this.buttonActiveClassname) {
                this.buttonActiveClassnames = this.buttonActiveClassname.split(' ')

                this.tabButtons.nativeElement.childNodes.forEach((el, index) => {
                    if (el instanceof HTMLElement && !!el?.dataset?.tabButtonNoEvents) {
                        if (childCount === this.activeTabIndex) {
                            el.classList.add(...this.buttonActiveClassnames)
                        }
                        childCount ++;
                    }
                })
            }

            this.tabButtons.nativeElement.onclick = (e: Event) => {
                const el = e.target
    
                if (el instanceof HTMLElement && !!el?.dataset?.tabButtonNoEvents) {
                    const index: string | undefined = el.dataset?.tabButtonIndex
    
                    if (index) {
                        this.tabButtons.nativeElement.childNodes.forEach(el => {
                            if (el instanceof HTMLElement) {
                                el.classList.remove(...this.buttonActiveClassnames)
                            }
                        })

                        el.classList.add(...this.buttonActiveClassnames)
                        this.switchActiveTab(index, this.setActiveTabContentOverrideIndexAs)

                    } else {
                        console.log('Missing data attribute - Tab button should contain attribute - data-tab-button-index="index"')
                    }
                }
            }
        }
    }

    switchActiveTab(index: string, tabContentIndexOverride?: number) {
        const idx = parseInt(index)
        
        if (tabContentIndexOverride) {
            this.activeTabContentClassname = `active-tab-${tabContentIndexOverride}`
        }
        else if (idx <= this.tabContent.nativeElement.children.length) {
            this.activeTabContentClassname = `active-tab-${idx}`
        }

        this.activeTabIndex = idx
        this.setActiveTabIndexAs = idx
        this.tabSwitched.emit(idx)
    }
}
